const KEY = "ss360_session_v1";

export function saveSession(session, persist) {
  const store = persist ? localStorage : sessionStorage;

  // Save persist flag inside the session so refresh can keep same storage
  const payload = { ...(session || {}), persist: !!persist };

  store.setItem(KEY, JSON.stringify(payload));
  // keep only one copy
  (persist ? sessionStorage : localStorage).removeItem(KEY);
}

export function loadSession() {
  const a = localStorage.getItem(KEY);
  const b = sessionStorage.getItem(KEY);
  return JSON.parse(a || b || "null");
}

export function clearSession() {
  localStorage.removeItem(KEY);
  sessionStorage.removeItem(KEY);
}
